import { Flex, Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';

const CommonSearch = ({ search, setSearch, setPage }) => {
  const setPageRef = useRef(setPage);
  setPageRef.current = setPage;
  const isFirstRender = useRef(true);

  const handleSearch = useCallback(
    (e) => {
      setSearch(e.target.value);
    },
    [setSearch],
  );

  // Reset to page 1 when search changes, but NOT on initial render
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const handler = setTimeout(() => {
      setPageRef.current(1);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  return (
    <>
      <Flex flexGrow="1">
        <Input
          type="search"
          name="search"
          marginLeft={{ sm: '0', md: 'auto' }}
          maxWidth="300px"
          width={{ base: '100%', md: 'auto' }}
          placeholder="Search"
          autoComplete="off"
          autoFocus={false}
          backgroundColor="#fff"
          border="1px solid #d8dadc"
          outline="none"
          _focus={{
            borderColor: '#e2e8f0',
            boxShadow: '0 0 0 1px #e2e8f0',
          }}
          _hover={{
            borderColor: '#e2e8f0',
          }}
          borderRadius="10px"
          value={search}
          onChange={handleSearch}
        />
      </Flex>
    </>
  );
};

CommonSearch.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
};

export default CommonSearch;
